// src/services/verificationService.js
import api from './api';

// Search personnel for verification
export const searchPersonnelForVerification = async (query) => {
  const response = await api.get(`/verification/search/${query}`);
  return response.data;
};

// Search clearing officer (Personnel in same command)
export const searchClearingOfficer = async (query, commandId) => {
  const response = await api.get(`/verification/search-clearing-officer/${query}?commandId=${commandId}`);
  return response.data;
};

// Submit pre-clearance
export const submitPreClearance = async (
  personnelId,
  clearingOfficerPersonnelId,   // Personnel.id of the actual Comptroller
  clearingOfficerServiceNumber,
  clearingOfficerName,
  notes
) => {
  const response = await api.post('/verification/pre-clearance', {
    personnelId,
    clearingOfficerPersonnelId,
    clearingOfficerServiceNumber,
    clearingOfficerName,
    notes: notes || undefined,
  });
  return response.data;
};

// Complete verification
export const completeVerification = async (verificationData) => {
  const response = await api.post('/verification/complete', verificationData);
  return response.data;
};

// Record non-verification
export const recordNonVerification = async ({ personnelId, reason, details }) => {
  const response = await api.post('/verification/non-verification', {
    personnelId,
    reason,
    details,
  });
  return response.data;
};


// ── Flagged recaptures (admin) ───────────────────────────────────────────────
export const getFlaggedList = async (view = 'pending', q = '') => {
  const response = await api.get('/verification/flagged', { params: { view, q: q || undefined } });
  return response.data;
};

export const getFlaggedPending = async (id) => {
  const response = await api.get(`/verification/flagged/pending/${id}`);
  return response.data;
};

export const getFlagDetails = async (flagId) => {
  const response = await api.get(`/verification/flagged/${flagId}`);
  return response.data;
};

export const runFlaggedFaceCheck = async (id) => {
  const response = await api.post(`/verification/flagged/pending/${id}/face-check`);
  return response.data;
};

export const approveFlaggedRecapture = async (id, { note, overrideWarning }) => {
  const response = await api.post(`/verification/flagged/pending/${id}/approve`, { note, overrideWarning });
  return response.data;
};

export const rejectFlaggedRecapture = async (id, { note }) => {
  const response = await api.post(`/verification/flagged/pending/${id}/reject`, { note });
  return response.data;
};

export const getFaceCheckHealth = async () => {
  const response = await api.get('/verification/flagged-health');
  return response.data;
};
